"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCodes = void 0;
exports.ErrorCodes = ['unknown-error', 'permission-denied', 'failed-precondition'];
//export type RequestResponse<Req, Res> = { request: Req; response: Res | ApiResponseError };
//# sourceMappingURL=base.js.map